var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.24381 3.13025L8.41181 2.39144V3.50412V11.4961C8.41181 11.724 8.22767 11.9081 7.99981 11.9081C7.78925 11.9081 7.61181 11.7416 7.61181 11.4961V3.50412V2.3973L6.7813 3.12894L3.7573 5.79295L3.75191 5.79769L3.74665 5.8026C3.58674 5.95185 3.34733 5.92785 3.22787 5.78083L3.21705 5.76751L3.20534 5.75497C3.06295 5.60241 3.06862 5.3513 3.24107 5.20041L3.24107 5.20042L3.24375 5.19805L7.73175 1.21404L7.73183 1.21414L7.74004 1.20651C7.85612 1.09873 8.03067 1.0694 8.19089 1.1457L8.26788 1.21404L12.7559 5.19805L12.7559 5.19806L12.7586 5.20041C12.9322 5.35236 12.9402 5.61272 12.8067 5.76777C12.6558 5.93934 12.4053 5.94474 12.253 5.8026L12.2531 5.80248L12.2438 5.79426L9.24381 3.13025ZM1.30781 15.1921V15.6921H1.80781H14.1918H14.6918V15.1921V13.8961C14.6918 13.6856 14.8583 13.5081 15.1038 13.5081C15.3317 13.5081 15.4918 13.6683 15.4918 13.8961V16.1041C15.4918 16.3168 15.3229 16.4921 15.1038 16.4921H0.895813C0.691955 16.4921 0.507812 16.308 0.507812 16.1041V13.8961C0.507812 13.677 0.683104 13.5081 0.895813 13.5081C1.14129 13.5081 1.30781 13.6856 1.30781 13.8961V15.1921Z",
    fill: "#0B907B",
    stroke: "#0B907B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload-icon.1040967e3b6b8947e0b32821c235fbb3.svg";
export { ForwardRef as ReactComponent };